(function () {
  'use strict';

  var STYLE_ID = 'frw-global-styles';
  var GAP = 16;

  function init() {
    document.querySelectorAll('[data-farbfluss-reviews]:not([data-frw-init])').forEach(function (el) {
      el.setAttribute('data-frw-init', '1');
      renderWidget(el);
    });
  }

  function cfgVal(el, key, fallback) {
    return el.dataset[key] !== undefined ? el.dataset[key] : fallback;
  }

  function renderWidget(container) {
    var api = cfgVal(container, 'api', '');
    if (!api) { console.warn('[farbfluss-reviews] data-api fehlt'); return; }

    var config = {
      api:           api,
      sort:          cfgVal(container, 'sort',          'relevant'),
      color:         cfgVal(container, 'color',         '#1a1a1a'),
      starColor:     cfgVal(container, 'starColor',     ''),
      bg:            cfgVal(container, 'bg',            'transparent'),
      cardBg:        cfgVal(container, 'cardBg',        '#ffffff'),
      textColor:     cfgVal(container, 'textColor',     '#1a1a1a'),
      fontSize:      cfgVal(container, 'fontSize',      '14'),
      fontFamily:    cfgVal(container, 'fontFamily',    'inherit'),
      showButton:    cfgVal(container, 'showButton',    'true') !== 'false',
      buttonText:    cfgVal(container, 'buttonText',    'Rezension schreiben'),
      buttonBg:      cfgVal(container, 'buttonBg',      ''),
      buttonColor:   cfgVal(container, 'buttonColor',   '#ffffff'),
      autoplay:      cfgVal(container, 'autoplay',      'true') !== 'false',
      speed:         parseInt(cfgVal(container, 'speed', '5000'), 10),
      radius:        cfgVal(container, 'radius',        '12'),
      placeId:       cfgVal(container, 'placeId',       'ChIJgev13l6PsUcRViqdKI-nUP4'),
      showHeaderBox: cfgVal(container, 'showHeaderBox', 'false') !== 'false',
      headerBoxBg:   cfgVal(container, 'headerBoxBg',   '#f5f5f5'),
      sidePadding:   cfgVal(container, 'sidePadding',   '0'),
      cardStyle:     cfgVal(container, 'cardStyle',     'solid'),
    };

    config.starColor = config.starColor || config.color;
    config.buttonBg  = config.buttonBg  || config.color;

    container.innerHTML = '<div class="frw-loading">Bewertungen werden geladen…</div>';

    var url = api.replace(/\/$/, '') + '/reviews' + (config.sort === 'newest' ? '?sort=newest' : '');

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.error || !data.reviews) {
          console.error('[farbfluss-reviews] API-Fehler:', data);
          container.innerHTML = '<p style="opacity:.5;padding:1rem;font-size:14px">' + (data && data.error ? data.error : 'Reviews nicht verfügbar') + '</p>';
          return;
        }
        buildWidget(container, config, data);
      })
      .catch(function (err) {
        console.error('[farbfluss-reviews] Fetch-Fehler:', err);
        container.innerHTML = '<p style="opacity:.5;padding:1rem;font-size:14px">Verbindungsfehler</p>';
      });
  }

  // ─── Stars ───────────────────────────────────────────────────────────────────

  function starsHtml(rating, color) {
    var r = Math.round(rating);
    return Array.from({ length: 5 }, function (_, i) {
      return '<span style="color:' + (i < r ? color : '#d9d9d9') + ';line-height:1">&#9733;</span>';
    }).join('');
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function truncate(text, len) {
    if (!text || text.length <= len) return text || '';
    return text.slice(0, len).replace(/\s+\S*$/, '') + '…';
  }

  var GOOGLE_LOGO =
    '<svg class="frw-google-logo" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
    + '<path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>'
    + '<path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>'
    + '<path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>'
    + '<path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>'
    + '</svg>';

  // ─── Build widget ─────────────────────────────────────────────────────────────

  function buildWidget(container, config, data) {
    injectStyles();

    var reviews   = data.reviews || [];
    var reviewUrl = (data.reviewsLink && data.reviewsLink !== 'null')
      ? data.reviewsLink
      : 'https://www.google.com/maps/place/?q=place_id:' + config.placeId;
    var uid       = 'frw-' + Math.random().toString(36).slice(2, 7);

    var headerInner =
      '<div class="frw-summary">'
        + '<div class="frw-big-score">' + data.rating.toFixed(1) + '</div>'
        + '<div>'
          + '<div class="frw-stars">' + starsHtml(data.rating, config.starColor) + '</div>'
          + '<div class="frw-total">' + data.total + ' Bewertungen · Google</div>'
        + '</div>'
      + '</div>'
      + (config.showButton
        ? '<a class="frw-cta-btn" href="' + reviewUrl + '" target="_blank" rel="noopener"'
          + ' style="background:' + config.buttonBg + ';color:' + config.buttonColor + ';border-radius:' + config.radius + 'px">'
          + esc(config.buttonText) + '</a>'
        : '');

    var header = config.showHeaderBox
      ? '<div class="frw-header-box" style="background:' + config.headerBoxBg + ';border-radius:' + config.radius + 'px">' + headerInner + '</div>'
      : '<div class="frw-header">' + headerInner + '</div>';

    var cardsHtml = reviews.map(function (r) { return buildCard(r, config); }).join('');

    container.innerHTML =
      '<div class="frw" style="'
        + '--frw-color:' + config.color + ';'
        + '--frw-star:' + config.starColor + ';'
        + '--frw-card-bg:' + config.cardBg + ';'
        + '--frw-text:' + config.textColor + ';'
        + '--frw-radius:' + config.radius + 'px;'
        + '--frw-fs:' + config.fontSize + 'px;'
        + '--frw-pad:' + config.sidePadding + 'px;'
        + 'font-family:' + config.fontFamily
      + '">'
        + header
        + '<div class="frw-carousel-wrap" id="' + uid + '-wrap">'
          + '<div class="frw-track-wrap">'
            + '<div class="frw-track" id="' + uid + '-track">' + cardsHtml + '</div>'
          + '</div>'
          + '<div class="frw-controls">'
            + '<button class="frw-arrow frw-prev" id="' + uid + '-prev" aria-label="Vorherige">&#8592;</button>'
            + '<div class="frw-dots" id="' + uid + '-dots"></div>'
            + '<button class="frw-arrow frw-next" id="' + uid + '-next" aria-label="Nächste">&#8594;</button>'
          + '</div>'
        + '</div>'
      + '</div>';

    initCarousel(container, uid, reviews.length, config);
    initReadMore(container);
  }

  function buildCard(r, config) {
    var initials  = r.author ? r.author.charAt(0).toUpperCase() : '?';
    var avatar    = r.photo
      ? '<img class="frw-avatar" src="' + esc(r.photo) + '" alt="' + esc(r.author) + '" loading="lazy">'
      : '<div class="frw-avatar frw-avatar-init">' + esc(initials) + '</div>';

    var short     = truncate(r.text, 120);
    var hasMore   = r.text && r.text.length > 120;
    var glassClass = config.cardStyle !== 'solid' ? ' frw-' + config.cardStyle : '';

    return '<div class="frw-card' + glassClass + '">'
      + '<div class="frw-card-top">'
        + avatar
        + '<div class="frw-card-meta">'
          + '<div class="frw-author">' + esc(r.author) + '</div>'
          + '<div class="frw-age">' + esc(r.age) + '</div>'
        + '</div>'
        + GOOGLE_LOGO
      + '</div>'
      + '<div class="frw-stars frw-stars-sm">' + starsHtml(r.rating, 'var(--frw-star)') + '</div>'
      + '<p class="frw-text frw-truncated" data-full="' + esc(r.text) + '" data-short="' + esc(short) + '">' + esc(short) + '</p>'
      + (hasMore ? '<button class="frw-more-btn">Mehr lesen</button>' : '')
    + '</div>';
  }

  // ─── Carousel ────────────────────────────────────────────────────────────────

  function initCarousel(container, uid, count, config) {
    if (count === 0) return;

    var track   = container.querySelector('#' + uid + '-track');
    var dotsEl  = container.querySelector('#' + uid + '-dots');
    var btnPrev = container.querySelector('#' + uid + '-prev');
    var btnNext = container.querySelector('#' + uid + '-next');
    var wrap    = container.querySelector('#' + uid + '-wrap');

    var showDots = count <= 8;
    if (showDots) {
      for (var d = 0; d < count; d++) {
        var dot = document.createElement('button');
        dot.className = 'frw-dot' + (d === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Bewertung ' + (d + 1));
        dotsEl.appendChild(dot);
      }
    }
    var dots = Array.from(dotsEl.querySelectorAll('.frw-dot'));

    var origCards  = Array.from(track.querySelectorAll('.frw-card'));
    var cloneFirst = origCards[0].cloneNode(true);
    var cloneLast  = origCards[count - 1].cloneNode(true);
    cloneFirst.setAttribute('aria-hidden', 'true');
    cloneLast.setAttribute('aria-hidden', 'true');
    track.appendChild(cloneFirst);
    track.insertBefore(cloneLast, origCards[0]);

    var current      = 1;
    var animating    = false;
    var animTimeout  = null;
    var timer        = null;
    var isSwiping    = false;
    var touchX       = 0;

    function cardW() {
      var c = track.querySelector('.frw-card');
      return c ? c.getBoundingClientRect().width + GAP : 0;
    }

    function moveTo(idx, anim) {
      clearTimeout(animTimeout);
      track.style.transition = anim ? 'transform 0.45s cubic-bezier(0.4,0,0.2,1)' : 'none';
      track.style.transform  = 'translateX(-' + (idx * cardW()) + 'px)';
      if (anim) {
        animating   = true;
        animTimeout = setTimeout(function () { animating = false; }, 500);
      }
      current = idx;
      var real = ((idx - 1) % count + count) % count;
      dots.forEach(function (dot, i) { dot.classList.toggle('active', i === real); });
    }

    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      clearTimeout(animTimeout);
      animating = false;
      if (current === 0)              moveTo(count, false);
      else if (current === count + 1) moveTo(1,     false);
    });

    function next() { if (!animating) moveTo(current + 1, true); }
    function prev() { if (!animating) moveTo(current - 1, true); }

    function resetTimer() {
      clearInterval(timer);
      if (config.autoplay) timer = setInterval(next, config.speed);
    }

    moveTo(1, false);

    btnNext.addEventListener('click', function () { next(); resetTimer(); });
    btnPrev.addEventListener('click', function () { prev(); resetTimer(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { moveTo(i + 1, true); resetTimer(); });
    });

    // Hover-pause only for real mouse, not synthetic touch events
    wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') clearInterval(timer); });
    wrap.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') resetTimer(); });

    // Touch swipe — ignore touches that start on controls (dots/arrows)
    wrap.addEventListener('touchstart', function (e) {
      if (e.target.closest('.frw-controls')) return;
      touchX    = e.touches[0].clientX;
      isSwiping = true;
      clearInterval(timer);
    }, { passive: true });

    wrap.addEventListener('touchend', function (e) {
      if (!isSwiping) { resetTimer(); return; }
      isSwiping = false;
      var diff  = touchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { diff > 0 ? next() : prev(); }
      resetTimer();
    }, { passive: true });

    wrap.addEventListener('touchcancel', function () {
      isSwiping = false;
      resetTimer();
    }, { passive: true });

    window.addEventListener('resize', function () { moveTo(current, false); });

    resetTimer();
  }

  // ─── Inline "Mehr lesen" ──────────────────────────────────────────────────────

  function initReadMore(container) {
    container.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.frw-more-btn');
      if (!btn) return;

      var card     = btn.closest('.frw-card');
      var textEl   = card.querySelector('.frw-text');
      var expanded = btn.dataset.expanded === 'true';

      if (expanded) {
        textEl.textContent = textEl.dataset.short;
        textEl.classList.add('frw-truncated');
        card.style.height   = '';
        card.style.overflow = '';
        btn.textContent     = 'Mehr lesen';
        btn.dataset.expanded = 'false';
      } else {
        textEl.textContent = textEl.dataset.full;
        textEl.classList.remove('frw-truncated');
        card.style.height   = 'auto';
        card.style.overflow = 'visible';
        btn.textContent     = 'Weniger';
        btn.dataset.expanded = 'true';
      }
    });
  }

  // ─── Styles ───────────────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id  = STYLE_ID;
    s.textContent = [
      '.frw{font-size:var(--frw-fs);color:var(--frw-text);padding-left:var(--frw-pad);padding-right:var(--frw-pad)}',
      '.frw-loading{padding:2rem;text-align:center;opacity:.5;font-family:inherit}',

      /* Header */
      '.frw-header,.frw-header-box{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:1rem;margin-bottom:1.75rem}',
      '.frw-header-box{padding:1.25rem 1.5rem}',
      '.frw-summary{display:flex;align-items:center;gap:1rem}',
      '.frw-big-score{font-size:3em;font-weight:700;line-height:1;color:var(--frw-color)}',
      '.frw-stars,.frw-stars-sm{display:flex;gap:2px;font-size:1.1em}',
      '.frw-total{font-size:.82em;opacity:.55;margin-top:4px}',
      '.frw-cta-btn{display:inline-flex;align-items:center;padding:.65em 1.3em;text-decoration:none;font-size:.875em;font-weight:500;transition:opacity .2s;white-space:nowrap}',
      '.frw-cta-btn:hover{opacity:.8}',

      /* Carousel */
      '.frw-carousel-wrap{position:relative}',
      '.frw-track-wrap{overflow:hidden;touch-action:pan-y}',
      '.frw-track{display:flex;gap:' + GAP + 'px;will-change:transform;align-items:flex-start}',

      /* Controls */
      '.frw-controls{display:flex;align-items:center;justify-content:center;gap:.75rem;margin-top:1.25rem}',
      '.frw-dots{display:flex;gap:6px;align-items:center}',
      '.frw-dot{width:8px;height:8px;border-radius:50%;border:none;background:rgba(0,0,0,.18);cursor:pointer;padding:0;transition:background .2s,transform .2s}',
      '.frw-dot.active{background:var(--frw-color);transform:scale(1.3)}',

      /* Glass arrows */
      '.frw-arrow{background:rgba(255,255,255,0.3);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);border:1px solid rgba(255,255,255,0.5);box-shadow:0 2px 10px rgba(0,0,0,0.1);border-radius:50%;width:38px;height:38px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:1rem;color:var(--frw-text);transition:background .2s,color .2s,border-color .2s;flex-shrink:0}',
      '.frw-arrow:hover{background:var(--frw-color);color:#fff;border-color:var(--frw-color)}',

      /* Cards */
      '.frw-card{flex:0 0 calc(33.333% - 11px);box-sizing:border-box;background:var(--frw-card-bg);border-radius:var(--frw-radius);padding:1.25rem;box-shadow:0 1px 6px rgba(0,0,0,.07);height:220px;display:flex;flex-direction:column;overflow:hidden}',
      '.frw-card.frw-glass-light{background:rgba(255,255,255,0.22)!important;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border:1px solid rgba(255,255,255,0.45)!important;box-shadow:0 4px 24px rgba(0,0,0,0.08)!important}',
      '.frw-card.frw-glass-dark{background:rgba(0,0,0,0.28)!important;backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);border:1px solid rgba(255,255,255,0.12)!important;box-shadow:0 4px 24px rgba(0,0,0,0.25)!important}',
      '@media(max-width:599px){.frw-card{flex:0 0 100%}}',
      '@media(min-width:600px) and (max-width:959px){.frw-card{flex:0 0 calc(50% - 8px)}}',

      /* Card internals */
      '.frw-card-top{display:flex;align-items:center;gap:.6rem;margin-bottom:.6rem;flex-shrink:0}',
      '.frw-avatar{width:36px;height:36px;border-radius:50%;object-fit:cover;flex-shrink:0}',
      '.frw-avatar-init{width:36px;height:36px;border-radius:50%;flex-shrink:0;background:rgba(0,0,0,.08);color:var(--frw-color);display:flex;align-items:center;justify-content:center;font-weight:600;font-size:.9em}',
      '.frw-card-meta{flex:1;min-width:0}',
      '.frw-author{font-weight:600;font-size:.875em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      '.frw-age{font-size:.75em;opacity:.5;margin-top:1px}',
      '.frw-google-logo{width:18px;height:18px;flex-shrink:0;margin-left:auto}',
      '.frw-stars-sm{margin-bottom:.5rem;flex-shrink:0}',
      '.frw-text{font-size:.875em;line-height:1.6;margin:0;flex:1;overflow:hidden}',
      '.frw-truncated{display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical}',
      '.frw-more-btn{background:none;border:none;color:var(--frw-color);font-size:.8em;cursor:pointer;padding:0;margin-top:4px;text-align:left;font-weight:500;flex-shrink:0}',
      '.frw-more-btn:hover{text-decoration:underline}',
    ].join('');
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
